// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_errorPageContainer__Lgd6U {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 5%;
}

.styles_errorPageHeaderText__T3Pv1 {
  font-size: 50px;
  font-weight: 700;
  text-align: center;
  width: 592px;
}

.styles_errorPageDescText__UqbHm {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  width: 404px;
}

.styles_errorPageBackButton__0yj6r {
  padding: 10px 16px;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  background: #3D3AD3;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
}

.styles_errorPageFirstConnector__FVVYn {
  position: fixed;
  bottom: 12%;
  right: 0;
}

.styles_errorPageSecondConnector__VnSBH {
  position: fixed;
  bottom: 0;
  left: 0;
}

@media screen and (max-width: 1720px) {
  .styles_errorPageContainer__Lgd6U {
    margin-top: 5%;
  }
  .styles_errorPageHeaderText__T3Pv1 {
    font-size: 45px;
    width: 550px;
  }
  .styles_errorPageDescText__UqbHm {
    font-size: 18px;
    width: 404px;
  }
  .styles_errorPageFirstConnector__FVVYn {
    width: 350px;
    height: 450px;
    bottom: 12%;
  }
  .styles_errorPageSecondConnector__VnSBH {
    width: 550px;
    height: 250px;
    bottom: 0;
    left: 0;
  }
}
@media screen and (max-width: 1440px) {
  .styles_errorPageContainer__Lgd6U {
    margin-top: 2%;
    gap: 12px;
  }
  .styles_errorPageHeaderText__T3Pv1 {
    font-size: 35px;
    width: 450px;
    line-height: 45px;
  }
  .styles_errorPageDescText__UqbHm {
    font-size: 14px;
    width: 300px;
    line-height: 24px;
  }
  .styles_errorPageBackButton__0yj6r {
    padding: 8px 14px;
    font-size: 10px;
    gap: 6px;
  }
  .styles_errorPageFirstConnector__FVVYn {
    width: 300px;
    height: 400px;
    bottom: 10%;
  }
  .styles_errorPageSecondConnector__VnSBH {
    width: 500px;
    height: 200px;
    bottom: 0;
    left: 0;
  }
}
@media screen and (max-width: 1280px) {
  .styles_errorPageContainer__Lgd6U {
    margin-top: 2%;
    gap: 10px;
  }
  .styles_errorPageHeaderText__T3Pv1 {
    font-size: 30px;
    width: 400px;
    line-height: 40px;
  }
  .styles_errorPageDescText__UqbHm {
    font-size: 12px;
    width: 250px;
    line-height: 24px;
  }
  .styles_errorPageBackButton__0yj6r {
    padding: 6px 12px;
    font-size: 10px;
    gap: 6px;
  }
  .styles_errorPageFirstConnector__FVVYn {
    width: 300px;
    height: 400px;
    bottom: 10%;
  }
  .styles_errorPageSecondConnector__VnSBH {
    width: 500px;
    height: 200px;
    bottom: 0;
    left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/ErrorBoundary/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAAJ;;AAIA;EACI,eAAA;EACA,WAAA;EACA,QAAA;AADJ;;AAIA;EACI,eAAA;EACA,SAAA;EACA,OAAA;AADJ;;AAIA;EACI;IACI,cAAA;EADN;EAIE;IACI,eAAA;IACA,YAAA;EAFN;EAME;IACI,eAAA;IACA,YAAA;EAJN;EAQE;IACI,YAAA;IACA,aAAA;IACA,WAAA;EANN;EASE;IACI,YAAA;IACA,aAAA;IACA,SAAA;IACA,OAAA;EAPN;AACF;AAUA;EACI;IACI,cAAA;IACA,SAAA;EARN;EAYE;IACI,eAAA;IACA,YAAA;IACA,iBAAA;EAVN;EAcE;IACI,eAAA;IACA,YAAA;IACA,iBAAA;EAZN;EAeE;IACI,iBAAA;IACA,eAAA;IACA,QAAA;EAbN;EAiBE;IACI,YAAA;IACA,aAAA;IACA,WAAA;EAfN;EAkBE;IACI,YAAA;IACA,aAAA;IACA,SAAA;IACA,OAAA;EAhBN;AACF;AAqBA;EACI;IACI,cAAA;IACA,SAAA;EAnBN;EAuBE;IACI,eAAA;IACA,YAAA;IACA,iBAAA;EArBN;EAyBE;IACI,eAAA;IACA,YAAA;IACA,iBAAA;EAvBN;EA0BE;IACI,iBAAA;IACA,eAAA;IACA,QAAA;EAxBN;EA4BE;IACI,YAAA;IACA,aAAA;IACA,WAAA;EA1BN;EA6BE;IACI,YAAA;IACA,aAAA;IACA,SAAA;IACA,OAAA;EA3BN;AACF","sourcesContent":[".errorPageContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 5%;\n}\n\n.errorPageHeaderText {\n    font-size: 50px;\n    font-weight: 700;\n    text-align: center;\n    width: 592px;\n}\n\n\n.errorPageDescText {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 30px;\n    width: 404px;\n}\n\n.errorPageBackButton {\n    padding: 10px 16px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 12px;\n    background: #3D3AD3;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 4px;\n}\n\n\n.errorPageFirstConnector {\n    position: fixed;\n    bottom: 12%;\n    right: 0;\n}\n\n.errorPageSecondConnector {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n}\n\n@media screen and (max-width: 1720px) {\n    .errorPageContainer {\n        margin-top: 5%;\n    }\n\n    .errorPageHeaderText {\n        font-size: 45px;\n        width: 550px;\n    }\n\n\n    .errorPageDescText {\n        font-size: 18px;\n        width: 404px;\n    }\n\n\n    .errorPageFirstConnector {\n        width: 350px;\n        height: 450px;\n        bottom: 12%;\n    }\n\n    .errorPageSecondConnector {\n        width: 550px;\n        height: 250px;\n        bottom: 0;\n        left: 0;\n    }\n}\n\n@media screen and (max-width: 1440px) {\n    .errorPageContainer {\n        margin-top: 2%;\n        gap: 12px;\n\n    }\n\n    .errorPageHeaderText {\n        font-size: 35px;\n        width: 450px;\n        line-height: 45px;\n    }\n\n\n    .errorPageDescText {\n        font-size: 14px;\n        width: 300px;\n        line-height: 24px;\n    }\n\n    .errorPageBackButton {\n        padding: 8px 14px;\n        font-size: 10px;\n        gap: 6px;\n    }\n    \n\n    .errorPageFirstConnector {\n        width: 300px;\n        height: 400px;\n        bottom: 10%;\n    }\n\n    .errorPageSecondConnector {\n        width: 500px;\n        height: 200px;\n        bottom: 0;\n        left: 0;\n    }\n\n}\n\n\n@media screen and (max-width: 1280px) {\n    .errorPageContainer {\n        margin-top: 2%;\n        gap: 10px;\n\n    }\n\n    .errorPageHeaderText {\n        font-size: 30px;\n        width: 400px;\n        line-height: 40px;\n    }\n\n\n    .errorPageDescText {\n        font-size: 12px;\n        width: 250px;\n        line-height: 24px;\n    }\n\n    .errorPageBackButton {\n        padding: 6px 12px;\n        font-size: 10px;\n        gap: 6px;\n    }\n\n\n    .errorPageFirstConnector {\n        width: 300px;\n        height: 400px;\n        bottom: 10%;\n    }\n\n    .errorPageSecondConnector {\n        width: 500px;\n        height: 200px;\n        bottom: 0;\n        left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorPageContainer": `styles_errorPageContainer__Lgd6U`,
	"errorPageHeaderText": `styles_errorPageHeaderText__T3Pv1`,
	"errorPageDescText": `styles_errorPageDescText__UqbHm`,
	"errorPageBackButton": `styles_errorPageBackButton__0yj6r`,
	"errorPageFirstConnector": `styles_errorPageFirstConnector__FVVYn`,
	"errorPageSecondConnector": `styles_errorPageSecondConnector__VnSBH`
};
export default ___CSS_LOADER_EXPORT___;
